import listActions from 'src/modules/inventario/list/inventarioListActions';
import InventarioService from 'src/modules/inventario/inventarioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'INVENTARIO_DESTROY';

const inventarioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: inventarioDestroyActions.DESTROY_STARTED,
      });

      await InventarioService.destroyAll([id]);

      dispatch({
        type: inventarioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.inventario.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/inventario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: inventarioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: inventarioDestroyActions.DESTROY_ALL_STARTED,
      });

      await InventarioService.destroyAll(ids);

      dispatch({
        type: inventarioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.inventario.destroyAll.success'),
      );

      getHistory().push('/inventario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: inventarioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default inventarioDestroyActions;
